import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { merge } from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import { Jumbotron } from 'reactstrap';
import InputComponent from '../common/input';
import NavBar from '../navBar/navBar';
import Header from '../common/header';
import {
  countWords,
  parseAccess,
  exportToCSV,
  importFromCSV,
  mergeExcludingExtraKeys,
} from '../common/helper';
import { db } from '../common/firebase';
import Loading from './Loading';
import TopBar from '../common/TopBar';
import 'react-toastify/dist/ReactToastify.css';
import ImageUpload from '../common/ImageUpload';
import ShowImage from '../common/ShowImage';
import './TranslationMain.css';

class TranslationMain extends Component {
  state = {
    brand: '',
    market: '',
    language: '',
    access: null,
    radioSelectedStatus: { label: 'Saved', value: 'Saved' },
    radioSelectedWarning: 'All',
    baseTrans: null,
    loading: false,
    selectedPage: null,
    pagesAccess: null,
    defaultPage: null,
    redirectTo: null,
    dirty: false,
    docReferenceBaseUnsuscibe: () => {},
    docReferenceTransUnsuscibe: () => {},
  };

  getPagesAndInputs(
    pageName,
    baseTrans,
    displayTranslation,
    radioSelectedWarning,
    summary
  ) {
    const jsx = Object.keys(baseTrans.pages[pageName])
      .sort()
      .map((moduleInstanceId) =>
        this.getPageInputs(
          moduleInstanceId,
          baseTrans,
          pageName,
          displayTranslation,
          radioSelectedWarning
        )
      )
      .filter(Boolean);

    return jsx[0] ? (
      <div key={pageName}>
        <h2>{pageName}</h2>
        <div>
          <small>{`Fields: ${
            summary &&
            summary.pages &&
            summary.pages[pageName] &&
            summary.pages[pageName].fields
              ? summary.pages[pageName].fields
              : ''
          }, Words: ${
            summary &&
            summary.pages &&
            summary.pages[pageName] &&
            summary.pages[pageName].words
              ? summary.pages[pageName].words
              : ''
          }`}</small>
        </div>
        {jsx}
      </div>
    ) : (
      ''
    );
  }

  getPageInputs(
    moduleInstanceId,
    baseTrans,
    pageName,
    displayTranslation,
    radioSelectedWarning
  ) {
    let hasValues = false;
    let jsx = (
      <div key={moduleInstanceId}>
        <h3>{`${baseTrans.pages[pageName][moduleInstanceId].moduleName} (${moduleInstanceId})`}</h3>
        <div className='inner-content'>
          {Object.keys(baseTrans.pages[pageName][moduleInstanceId])
            .filter((key) => key !== 'moduleName')
            .sort()
            .map((key) => {
              if (
                typeof baseTrans.pages[pageName][moduleInstanceId][key] ===
                'string'
              ) {
                const value =
                  (displayTranslation &&
                    displayTranslation.pages &&
                    displayTranslation.pages[pageName] &&
                    displayTranslation.pages[pageName][moduleInstanceId] &&
                    displayTranslation.pages[pageName][moduleInstanceId][
                      key
                    ]) ||
                  '';
                const label =
                  baseTrans.pages[pageName][moduleInstanceId][key] || '';
                if (!label) return '';
                hasValues = true;

                const styleClass =
                  label.length > 200 ? 'one-long-field' : 'one-field';

                return (
                  <div
                    key={`${moduleInstanceId}-${key}`}
                    className={styleClass}
                  >
                    <InputComponent
                      className='vdp-text-input'
                      name={`${moduleInstanceId}-${key}`}
                      onChange={(eventData) =>
                        this.setFormData(
                          'pages',
                          moduleInstanceId,
                          key,
                          eventData,
                          pageName
                        )
                      }
                      helpText={key}
                      label={label}
                      value={value}
                      isEmpty={!value ? value.trim() === '' : false}
                      isWarning={value ? value.trim() === label : false}
                    />
                  </div>
                );
              }

              return (
                <div key={`${moduleInstanceId}-${key}`}>
                  <div>
                    <h4>{`item-${key}`}</h4>
                    {baseTrans.pages[pageName][moduleInstanceId][key] &&
                      Object.keys(
                        baseTrans.pages[pageName][moduleInstanceId][key]
                      )
                        .sort()
                        .filter((item) => item !== 'moduleName')
                        .map((item) => {
                          const value =
                            (displayTranslation &&
                              displayTranslation.pages &&
                              displayTranslation.pages[pageName] &&
                              displayTranslation.pages[pageName][
                                moduleInstanceId
                              ] &&
                              displayTranslation.pages[pageName][
                                moduleInstanceId
                              ][key] &&
                              displayTranslation.pages[pageName][
                                moduleInstanceId
                              ][key][item]) ||
                            '';
                          const label =
                            baseTrans.pages[pageName][moduleInstanceId][key][
                              item
                            ] || '';
                          if (!label) return '';

                          if (radioSelectedWarning === 'Empty' && value)
                            return '';
                          if (
                            radioSelectedWarning === 'Warning' &&
                            value !== label
                          )
                            return '';
                          hasValues = true;

                          const styleClass =
                            label.length > 200 ? 'one-long-field' : 'one-field';

                          return (
                            <div
                              key={`${moduleInstanceId}-${key}-${item}-div`}
                              className={styleClass}
                            >
                              {baseTrans.pages[pageName][moduleInstanceId]
                                .moduleName === 'Brick' && item === 'link' ? (
                                <Fragment>
                                  <InputComponent
                                    className='vdp-text-input'
                                    name={`${moduleInstanceId}-${key}-${item}`}
                                    key={`${moduleInstanceId}-${key}-${item}`}
                                    onBlur={this.validURL(
                                      `${moduleInstanceId}-${key}-${item}`
                                    )}
                                    onChange={(eventData) =>
                                      this.setFormData(
                                        'pages',
                                        moduleInstanceId,
                                        key,
                                        eventData,
                                        pageName,
                                        item
                                      )
                                    }
                                    helpText={item}
                                    label={label}
                                    value={value}
                                    isEmpty={
                                      !value ? value.trim() === '' : false
                                    }
                                    isWarning={
                                      value ? value.trim() === label : false
                                    }
                                  />
                                  <section
                                    id={`${moduleInstanceId}-${key}-${item}-valid`}
                                    style={{
                                      fontSize: '1rem',
                                      fontStyle: 'italic',
                                      color: '#FF0000',
                                      fontWeight: 'bold',
                                    }}
                                  />
                                </Fragment>
                              ) : (
                                <InputComponent
                                  className='vdp-text-input'
                                  name={`${moduleInstanceId}-${key}-${item}`}
                                  key={`${moduleInstanceId}-${key}-${item}`}
                                  onChange={(eventData) =>
                                    this.setFormData(
                                      'pages',
                                      moduleInstanceId,
                                      key,
                                      eventData,
                                      pageName,
                                      item
                                    )
                                  }
                                  helpText={item}
                                  label={label}
                                  value={value}
                                  isEmpty={!value ? value.trim() === '' : false}
                                  isWarning={
                                    value ? value.trim() === label : false
                                  }
                                />
                              )}

                              {baseTrans.pages[pageName][moduleInstanceId]
                                .moduleName === 'Hero Carousel' &&
                                item === 'image' && (
                                  <Fragment>
                                    <ShowImage
                                      cloudName='motortrak'
                                      publicId={value}
                                      label={label}
                                    />
                                    <ImageUpload
                                      brand={this.state.brand}
                                      path='https://res.cloudinary.com/motortrak/image/upload'
                                      inputField={`${moduleInstanceId}-${key}-image`}
                                    />
                                  </Fragment>
                                )}
                            </div>
                          );
                        })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );

    jsx = hasValues ? jsx : '';

    return jsx;
  }

  getGlobalInputs(
    moduleInstanceId,
    baseTrans,
    displayTranslation,
    radioSelectedWarning,
    summary
  ) {
    let hasValues = false;
    let jsx = (
      <div key={moduleInstanceId}>
        <h3>{`${baseTrans.global[moduleInstanceId].moduleName} (${moduleInstanceId})`}</h3>
        <div>
          <small>{`Fields: ${
            summary && summary.global && summary.global.fields
              ? summary.global.fields
              : ''
          }, Words: ${
            summary && summary.global && summary.global.words
              ? summary.global.words
              : ''
          }`}</small>
        </div>
        {Object.keys(baseTrans.global[moduleInstanceId])
          .filter((key) => key !== 'moduleName')
          .sort()
          .map((key) => {
            const value =
              (displayTranslation &&
                displayTranslation.global &&
                displayTranslation.global[moduleInstanceId] &&
                displayTranslation.global[moduleInstanceId][key]) ||
              '';
            const label = baseTrans.global[moduleInstanceId][key] || '';
            if (!label) return '';
            if (radioSelectedWarning === 'Empty' && value) return '';
            if (radioSelectedWarning === 'Warning' && value !== label)
              return '';
            hasValues = true;

            return (
              <div
                key={`${moduleInstanceId}-${key}`}
              >
                <InputComponent
                  className='vdp-text-input'
                  name={`${moduleInstanceId}-${key}`}
                  onChange={(eventData) =>
                    this.setFormData('global', moduleInstanceId, key, eventData)
                  }
                  helpText={key}
                  label={label}
                  value={value}
                  isEmpty={!value ? value.trim() === '' : false}
                  isWarning={value ? value.trim() === label : false}
                />
              </div>
            );
          })}
      </div>
    );

    jsx = hasValues ? jsx : '';

    return jsx;
  }

  setDisplayTranslation = (
    alternativeTrans,
    publishedTrans,
    brand,
    market,
    language
  ) => {
    const { radioSelectedStatus } = this.state;
    const displayTranslation =
      radioSelectedStatus.value === 'Saved'
        ? alternativeTrans || publishedTrans
        : publishedTrans;
    this.setState({
      alternativeTrans,
      publishedTrans,
      brand,
      market,
      language,
      displayTranslation,
    });
  };

  setValueToField = (fields, value) => {
    const reducer = (acc, item, index, arr) => ({
      [item]: index + 1 < arr.length ? acc : value,
    });
    return fields.reduceRight(reducer, {});
  };

  calculateBadges = () => {
    const { baseTrans, alternativeTrans, publishedTrans } =
      this.state;

    if (!baseTrans) return;

    const summary = {};

    // iterate through global items
    summary.global = {};
    summary.global.empty = 0;
    summary.global.warning = 0;
    summary.global.unpublished = 0;
    summary.global.fields = 0;
    summary.global.words = 0;

    if (baseTrans && baseTrans.global)
      Object.keys(baseTrans.global).forEach((moduleInstanceId) => {
        Object.keys(baseTrans.global[moduleInstanceId])
          .filter(
            (key) =>
              key !== 'moduleName' && baseTrans.global[moduleInstanceId][key]
          )
          .forEach((key) => {
            if (typeof baseTrans.global[moduleInstanceId][key] === 'string') {
              const baseText = baseTrans.global[moduleInstanceId][key];
              const translation =
                (alternativeTrans &&
                  alternativeTrans.global &&
                  alternativeTrans.global[moduleInstanceId] &&
                  alternativeTrans.global[moduleInstanceId][key]) ||
                '';
              const publishedText =
                (publishedTrans &&
                  publishedTrans.global &&
                  publishedTrans.global[moduleInstanceId] &&
                  publishedTrans.global[moduleInstanceId][key]) ||
                '';

              summary.global.fields += 1;
              summary.global.words += countWords(baseText);

              // check for missing translations
              if (!translation) summary.global.empty += 1;

              // check for warnings
              if (baseText && translation === baseText) {
                summary.global.warning += 1;
              }

              // check for not published texts
              if (baseText && publishedText !== translation)
                summary.global.unpublished += 1;
            }
          });
      });

    // iterate through page items
    summary.pages = {};

    Object.keys(baseTrans.pages).forEach((pageName) => {
      summary.pages[pageName] = {};
      summary.pages[pageName].empty = 0;
      summary.pages[pageName].warning = 0;
      summary.pages[pageName].unpublished = 0;
      summary.pages[pageName].fields = 0;
      summary.pages[pageName].words = 0;

      Object.keys(baseTrans.pages[pageName]).forEach((moduleInstanceId) => {
        Object.keys(baseTrans.pages[pageName][moduleInstanceId])
          .filter(
            (key) =>
              key !== 'moduleName' &&
              baseTrans.pages[pageName][moduleInstanceId][key]
          )
          .forEach((key) => {
            if (
              typeof baseTrans.pages[pageName][moduleInstanceId][key] ===
              'string'
            ) {
              const baseText = baseTrans.pages[pageName][moduleInstanceId][key];
              const translation =
                (alternativeTrans &&
                  alternativeTrans.pages &&
                  alternativeTrans.pages[pageName] &&
                  alternativeTrans.pages[pageName][moduleInstanceId] &&
                  alternativeTrans.pages[pageName][moduleInstanceId][key]) ||
                '';
              const publishedText =
                (publishedTrans &&
                  publishedTrans.pages &&
                  publishedTrans.pages[pageName] &&
                  publishedTrans.pages[pageName][moduleInstanceId] &&
                  publishedTrans.pages[pageName][moduleInstanceId][key]) ||
                '';

              summary.pages[pageName].fields += 1;
              summary.pages[pageName].words += countWords(baseText);

              // check for missing translations
              if (!translation && baseText) summary.pages[pageName].empty += 1;

              // check for warnings
              if (baseText && baseText === translation) {
                summary.pages[pageName].warning += 1;
              }

              // check for not published texts
              if (baseText && publishedText !== translation)
                summary.pages[pageName].unpublished += 1;
            } else {
              Object.keys(baseTrans.pages[pageName][moduleInstanceId][key])
                .filter(
                  (item) =>
                    item !== 'moduleName' &&
                    baseTrans.pages[pageName][moduleInstanceId][key] &&
                    baseTrans.pages[pageName][moduleInstanceId][key][item]
                )
                .forEach((item) => {
                  const baseText =
                    baseTrans.pages[pageName][moduleInstanceId][key][item];
                  const translation =
                    (alternativeTrans &&
                      alternativeTrans.pages &&
                      alternativeTrans.pages[pageName] &&
                      alternativeTrans.pages[pageName][moduleInstanceId] &&
                      alternativeTrans.pages[pageName][moduleInstanceId][key] &&
                      alternativeTrans.pages[pageName][moduleInstanceId][key][
                        item
                      ]) ||
                    '';
                  const publishedText =
                    (publishedTrans &&
                      publishedTrans.pages &&
                      publishedTrans.pages[pageName] &&
                      publishedTrans.pages[pageName][moduleInstanceId] &&
                      publishedTrans.pages[pageName][moduleInstanceId][key] &&
                      publishedTrans.pages[pageName][moduleInstanceId][key][
                        item
                      ]) ||
                    '';

                  summary.pages[pageName].fields += 1;
                  summary.pages[pageName].words += countWords(baseText);

                  // check for missing translations
                  if (!translation) summary.pages[pageName].empty += 1;

                  // check for warnings
                  if (baseText && translation === baseText)
                    summary.pages[pageName].warning += 1;

                  // check for not published texts
                  if (baseText && publishedText !== translation)
                    summary.pages[pageName].unpublished += 1;
                });
            }
          });
      });
    });

    this.setState({ summary });
  };

  suscribeToContent = (brand, market, language) => {
    this.setState({ loading: true });
    const { docReferenceBaseUnsuscibe, docReferenceTransUnsuscibe } =
      this.state;

    docReferenceBaseUnsuscibe();
    docReferenceTransUnsuscibe();

    const newDocReferenceBaseUnsuscibe = db
      .doc(`brand/${brand.toLowerCase()}/market/${market.toLowerCase()}`)
      .onSnapshot((snapshot) => {
        const dbContentForBase = snapshot.data();
        const baseTrans = (dbContentForBase && dbContentForBase.base) || null;
        this.setState({ baseTrans, brand, market, language });
        this.setState({ loading: false });
        this.calculateBadges();
      });

    const newDocReferenceTransUnsuscibe = db
      .doc(
        `brand/${brand.toLowerCase()}/market/${market.toLowerCase()}/language/${language
          .toLowerCase()
          .replace('_', '-')}`
      )
      .onSnapshot((snapshot) => {
        const dbContentForLanguage = snapshot.data();
        const alternativeTrans =
          (dbContentForLanguage && dbContentForLanguage.saved) || '';
        const publishedTrans =
          (dbContentForLanguage && dbContentForLanguage.published) || '';
        this.setDisplayTranslation(
          alternativeTrans,
          publishedTrans,
          brand,
          market,
          language
        );
        this.calculateBadges();
      });

    this.setState({
      docReferenceBaseUnsuscibe: newDocReferenceBaseUnsuscibe,
      docReferenceTransUnsuscibe: newDocReferenceTransUnsuscibe,
    });
  };

  componentWillUnmount = () => {
    const { docReferenceBaseUnsuscibe, docReferenceTransUnsuscibe } =
      this.state;
    docReferenceBaseUnsuscibe();
    docReferenceTransUnsuscibe();
  };

  onCloseEventTriggered = (event) => {
    const { dirty } = this.state;
    const dialogText =
      'You have data that has not been saved yet, are you sure you want to leave the page?';

    if (!dirty) {
      return;
    }

    event.returnValue = dialogText;
    return dialogText;
  };

  componentDidMount = () => {
    const { access, defaultValue } = this.props;
    window.onbeforeunload = this.onCloseEventTriggered;
    this.setBrandsMarketsLanguages(access, defaultValue);
    this.setState({ access });
  };

  setBrandsMarketsLanguages = (access, currentSelection) => {
    const { brands, markets, languages, pages, brand, market, language } =
      parseAccess(access, currentSelection);

    if (pages && pages.length && pages.length > 0)
      this.setState({ defaultPage: pages[0] });
    else this.setState({ defaultPage: 'Global' });

    this.setState({ brands, markets, languages, pagesAccess: pages });
    this.setState({ brand, market, language });
    this.suscribeToContent(brand, market, language);
  };

  radioClickedStatus = (item) => {
    const { alternativeTrans, publishedTrans } = this.state;
    const displayTranslation =
      item === 'Saved' ? alternativeTrans : publishedTrans;
    const radioSelectedStatus =
      item === 'Saved'
        ? { label: 'Saved', value: 'Saved' }
        : { label: 'Published', value: 'Published' };
    this.setState({ displayTranslation, radioSelectedStatus });
  };

  radioClickedWarning = (item) => {
    this.setState({ radioSelectedWarning: item });
  };

  radioClickedLanguage = (item) => {
    const { access, brand, market } = this.state;
    const currentSelection = {
      brand,
      market,
      language: item,
    };
    this.setBrandsMarketsLanguages(access, currentSelection);
  };

  radioClickedMarket = (item) => {
    const { access, brand } = this.state;
    const currentSelection = {
      brand,
      market: item,
      language: null,
    };
    this.setBrandsMarketsLanguages(access, currentSelection);
  };

  radioClickedBrand = (item) => {
    const { access } = this.state;
    const currentSelection = {
      brand: item,
      market: null,
      language: null,
    };
    this.setBrandsMarketsLanguages(access, currentSelection);
  };

  publishTranslation = (
    brand,
    market,
    language,
    alternativeTrans,
    radioSelectedStatus,
    baseTrans,
    userName,
    strictMerge = false
  ) =>
    new Promise((resolve, reject) => {
      if (!market || !brand || !language) {
        reject(new Error('You have no client or translation assigned'));
      }

      if (radioSelectedStatus.value === 'Published') {
        reject(new Error('You are currently viewing a Published version'));
      }

      const docReferenceTrans = db.doc(
        `brand/${brand.toLowerCase()}/market/${market.toLowerCase()}/language/${language
          .toLowerCase()
          .replace('_', '-')}`
      );

      /* 
        Switch this to erase every translation available for old moduleIds
      */
      strictMerge = false;

      return docReferenceTrans
        .set(
          {
            saved: Object.assign(
              {},
              strictMerge
                ? mergeExcludingExtraKeys(baseTrans, alternativeTrans)
                : alternativeTrans
            ),
            lastSaveDate: Date.now(),
            saveUser: userName,
            lastPublishDate: Date.now(),
            published: Object.assign(
              {},
              strictMerge
                ? mergeExcludingExtraKeys(baseTrans, alternativeTrans)
                : alternativeTrans
            ),
            publishUser: userName,
          },
          { merge: !strictMerge }
        )
        .then(() => resolve())
        .catch((err) => reject(err));
    });

  loadCSVFile = (event, brand, market, language) => {
    const input = event.target;
    if ('files' in input && input.files.length > 0) {
      const fileName = input.files[0].name.split('.')[0];
      const extension = input.files[0].name.split('.')[1];
      const parsedFileName = fileName.split('$');

      if (extension !== 'csv') {
        toast.error(
          `The file must be a valid csv, with a csv file extension, as the original file was, you sent a ${extension}`
        );
        return;
      }
      if (parsedFileName.length !== 3) {
        toast.error(
          'The filename has to be formatted in the following way: \nlanguage$market$brand.csv'
        );
        return;
      }
      if (
        parsedFileName[0].toLowerCase() !== language.toLowerCase() ||
        parsedFileName[1].toLowerCase() !== market.toLowerCase() ||
        parsedFileName[2].toLowerCase() !== brand.toLowerCase()
      ) {
        toast.error(
          'The brand, language or market selected are not the same as the ones currently being displayed'
        );
        return;
      }

      importFromCSV(input.files[0], brand, market, language)
        .then((newTranslation) => {
          const {
            alternativeTrans,
            publishedTrans,
            brand,
            market,
            language,
          } = this.state;

          this.setDisplayTranslation(
            merge(alternativeTrans, newTranslation),
            publishedTrans,
            brand,
            market,
            language
          );
          this.calculateBadges();

          toast.success(
            'Done! Please remember to save once you are sure that the imported translations are correct',
            {
              autoClose: false,
            }
          );
        })
        .catch((err) => toast.error(err.message));
    }
    this.fileInputBase.value = null;
  };

  saveChanges = (
    brand,
    market,
    language,
    alternativeTrans,
    radioSelectedStatus,
    userName
  ) => {
    if (radioSelectedStatus.value === 'Published') {
      return Promise.reject(
        new Error("You are currently viewing a Published version, can't save")
      );
    }

    const docReferenceTrans = db.doc(
      `brand/${brand.toLowerCase()}/market/${market.toLowerCase()}/language/${language
        .toLowerCase()
        .replace('_', '-')}`
    );
    return docReferenceTrans.set(
      {
        saved: Object.assign({}, alternativeTrans),
        lastSaveDate: Date.now(),
        saveUser: userName,
      },
      { merge: true }
    );
  };

  setFormData = (section, iid, key, eventData, pageName, item) => {
    let { displayTranslation } = this.state;
    const { radioSelectedStatus } = this.state;

    if (radioSelectedStatus.value === 'Published') {
      toast.error("Can't work directly on published version", {
        toastId: 'publishedErrorId',
      });
      return;
    }

    if (!displayTranslation) displayTranslation = {};
    if (!displayTranslation[section]) displayTranslation[section] = {};
    if (!pageName) {
      if (!displayTranslation[section][iid])
        displayTranslation[section][iid] = {};
      if (!displayTranslation[section][iid][key])
        displayTranslation[section][iid][key] = {};
      displayTranslation[section][iid][key] = eventData.target.value;
    } else if (!item) {
      if (!displayTranslation[section][pageName])
        displayTranslation[section][pageName] = {};
      if (!displayTranslation[section][pageName][iid])
        displayTranslation[section][pageName][iid] = {};
      if (!displayTranslation[section][pageName][iid][key])
        displayTranslation[section][pageName][iid][key] = {};
      displayTranslation[section][pageName][iid][key] = eventData.target.value;
    } else {
      if (!displayTranslation[section][pageName])
        displayTranslation[section][pageName] = {};
      if (!displayTranslation[section][pageName][iid])
        displayTranslation[section][pageName][iid] = {};
      if (!displayTranslation[section][pageName][iid][key])
        displayTranslation[section][pageName][iid][key] = {};
      if (!displayTranslation[section][pageName][iid][key][item])
        displayTranslation[section][pageName][iid][key][item] = {};
      displayTranslation[section][pageName][iid][key][item] =
        eventData.target.value;
    }

    this.setState({ dirty: true });
    this.setState({ alternativeTrans: displayTranslation, displayTranslation });
  };

  validURL = (linkField) => {
    const expression =
      /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
    const regex = new RegExp(expression);
    const input = document.getElementsByName(linkField)[0];
    const warning = document.getElementById(linkField + '-valid');

    if (typeof input !== 'undefined') {
      const url = input.value;
      const value = url.startsWith('/');

      if (input.value !== '') {
        if (url.match(regex) || value) {
          warning.innerHTML = '';
        } else {
          warning.innerHTML = 'Please enter a valid url address';
        }
      } else {
        warning.innerHTML = '';
      }
    }
  };

  logOut = () => {
    const { logOut } = this.props;
    logOut();
  };

  render() {
    const {
      baseTrans,
      language,
      market,
      brand,
      loading,
      displayTranslation,
      radioSelectedStatus,
      radioSelectedWarning,
      pagesAccess,
      defaultPage,
      summary,
      redirectTo,
      access,
    } = this.state;

    let { selectedPage } = this.state;
    const {
      user,
      canSeeFinance,
      canSave,
      canPublish,
      isAdmin,
      canDownloadBase,
    } = this.props;

    selectedPage = selectedPage || defaultPage;

    if (loading) {
      return <Loading />;
    }

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    if (!baseTrans) {
      return (
        <div>
          <ToastContainer />
          <div className='realNavBar'>
            <NavBar
              options={
                baseTrans &&
                Object.keys(baseTrans.pages).filter(
                  (pageName) =>
                    !pagesAccess || pagesAccess.indexOf(pageName) > -1
                )
              }
              showGlobal={!pagesAccess || pagesAccess.indexOf('Global') > -1}
              authenticated
              selected={selectedPage}
              logOut={this.logOut}
              onClick={(item) => {
                this.calculateBadges();
                this.setState({ selectedPage: item });
              }}
              exportToCSV={() => {
                exportToCSV(brand, market, language);
              }}
              importFromCSV={() => {
                this.fileInputBase.click();
              }}
              saveChanges={() => {
                this.saveChanges(
                  brand,
                  market,
                  language,
                  displayTranslation,
                  radioSelectedStatus,
                  user.email
                )
                  .then(() => {
                    this.calculateBadges();
                    this.setState({ dirty: false });
                    toast.success('Translation Saved');
                  })
                  .catch((err) => {
                    toast.error(
                      `There was a problem saving the translation \n ${err.message}`
                    );
                  });
              }}
              publishChanges={() =>
                this.publishTranslation(
                  brand,
                  market,
                  language,
                  displayTranslation,
                  radioSelectedStatus,
                  baseTrans,
                  user.email
                )
                  .then(() => {
                    this.calculateBadges();
                    this.setState({ dirty: false });
                    toast.success('Translation Saved and Published');
                  })
                  .catch((err) => {
                    toast.error(
                      `There was a problem saving the translation. \n ${err.message}`
                    );
                  })
              }
              canSave={!!canSave}
              canPublish={!!canPublish}
              isAdmin={!!isAdmin}
              summary={summary}
              redirectToUserAdministration={() =>
                this.setState({ redirectTo: '/UserAdministration' })
              }
            />
          </div>

          <div className='vehicle-view-wrapper'>
            <div className='navBar vehicle-view-navBar' />
            <div className='header vehicle-view-header'>
              <Header label='Translations' />
            </div>

            <TopBar
              radioSelectedStatus={radioSelectedStatus}
              radioClickedStatus={this.radioClickedStatus}
              radioSelectedWarning={radioSelectedWarning}
              radioClickedWarning={this.radioClickedWarning}
              radioClickedBrand={this.radioClickedBrand}
              radioClickedMarket={this.radioClickedMarket}
              radioClickedLanguage={this.radioClickedLanguage}
              canDownloadBase={!!canDownloadBase}
              access={access}
              language={language}
              brand={brand}
              market={market}
            />

            <div>
              <Jumbotron>
                <h3>No base for that selection</h3>
              </Jumbotron>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <ToastContainer />
        <div className='realNavBar'>
          <NavBar
            options={
              baseTrans &&
              Object.keys(baseTrans.pages).filter(
                (pageName) => !pagesAccess || pagesAccess.indexOf(pageName) > -1
              )
            }
            showGlobal={!pagesAccess || pagesAccess.indexOf('Global') > -1}
            authenticated
            selected={selectedPage}
            logOut={this.logOut}
            onClick={(item) => {
              this.calculateBadges();

              this.setState({ selectedPage: item });
            }}
            exportToCSV={() => {
              exportToCSV(brand, market, language);
            }}
            importFromCSV={() => {
              this.fileInputBase.click();
            }}
            canSave={!!canSave}
            canPublish={!!canPublish}
            isAdmin={!!isAdmin}
            saveChanges={() => {
              this.saveChanges(
                brand,
                market,
                language,
                displayTranslation,
                radioSelectedStatus,
                user.email
              )
                .then(() => {
                  this.calculateBadges();
                  this.setState({ dirty: false });
                  toast.success('Translation Saved');
                })
                .catch((err) => {
                  toast.error(
                    `There was a problem saving the translation \n ${err.message}`
                  );
                });
            }}
            publishChanges={() =>
              this.publishTranslation(
                brand,
                market,
                language,
                displayTranslation,
                radioSelectedStatus,
                baseTrans,
                user.email
              )
                .then(() => {
                  this.calculateBadges();
                  this.setState({ dirty: false });
                  toast.success('Translation Saved and Published');
                })
                .catch((err) => {
                  toast.error(
                    `There was a problem saving the translation \n ${err.message}`
                  );
                })
            }
            summary={summary}
            redirectToUserAdministration={() =>
              this.setState({ redirectTo: '/UserAdministration' })
            }
          />
          <input
            type='file'
            style={{ display: 'none' }}
            accept='.csv'
            ref={(fileInputBase) => {
              this.fileInputBase = fileInputBase;
            }}
            onChange={(e) => {
              e.preventDefault();
              this.loadCSVFile(e, brand, market, language);
            }}
          />
        </div>

        <div className='vehicle-view-wrapper'>
          <div className='navBar vehicle-view-navBar' />
          <div className='header vehicle-view-header' />
          <div className='translation-header-topbar'>
            <div>
              <Header label='Translations' />
            </div>
            <div>
              <TopBar
                radioSelectedStatus={radioSelectedStatus}
                radioClickedStatus={this.radioClickedStatus}
                radioSelectedWarning={radioSelectedWarning}
                radioClickedWarning={this.radioClickedWarning}
                radioClickedBrand={this.radioClickedBrand}
                radioClickedMarket={this.radioClickedMarket}
                radioClickedLanguage={this.radioClickedLanguage}
                access={access}
                canDownloadBase={!!canDownloadBase}
                language={language}
                brand={brand}
                market={market}
              />
            </div>
          </div>

          <div className='vehicle-view-title-pricing'>
            {(!selectedPage || selectedPage === 'Global') &&
            (!pagesAccess || pagesAccess.indexOf('Global') > -1)
              ? 'Global'
              : ''}
          </div>
          <div className='vehicle-view-pricing-section'>
            {(!selectedPage || selectedPage === 'Global') &&
            (!pagesAccess || pagesAccess.indexOf('Global') > -1) &&
            baseTrans &&
            baseTrans.global
              ? Object.keys(baseTrans.global)
                  .filter((x) => x !== '$GLOBAL_FINANCE$' || canSeeFinance)
                  .map((moduleInstanceId) =>
                    this.getGlobalInputs(
                      moduleInstanceId,
                      baseTrans,
                      displayTranslation,
                      radioSelectedWarning,
                      summary
                    )
                  )
              : ''}
          </div>
          <div className='vehicle-view-title-pricing'>
            {!selectedPage || selectedPage !== 'Global' ? 'Pages' : ''}
          </div>
          <div className='vehicle-view-pricing-section'>
            {Object.keys(baseTrans.pages)
              .filter((x) => x === selectedPage || !selectedPage)
              .filter(
                (pageName) => !pagesAccess || pagesAccess.indexOf(pageName) > -1
              )
              .map((pageName) =>
                this.getPagesAndInputs(
                  pageName,
                  baseTrans,
                  displayTranslation,
                  radioSelectedWarning,
                  summary
                )
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default TranslationMain;
